import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SkeletonSizeBase } from '../..';
export type TypeSize = 'default' | 'small' | 'middle' | 'large';

@Component({
  selector: 'skc-rectangle',
  templateUrl: './rectangle.component.html',
  styleUrls: ['./rectangle.component.less']
})
export class RectangleComponent extends SkeletonSizeBase implements OnInit, OnChanges {
  @Input('skc-size') size: TypeSize = 'default';

  constructor() {
    super();
  }

  ngOnInit() {
    this.initProperties();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.size) {
      this.adjustSize();
    }
    if (
      (changes.width && !changes.width.firstChange && changes.width.currentValue === '') ||
      (changes.height && !changes.height.firstChange && changes.height.currentValue === '')
    ) {
      this.initProperties();
    }
  }

  private initProperties() {
    if (!this.height) {
      this.height = '2.5em';
    }
    if (!this.width) {
      this.width = '6.25em';
    }
    if (!this.size) {
      this.size = 'default';
    }
  }

  private adjustSize() {
    switch (this.size.toLowerCase()) {
      case 'small':
        this.height = '1.25em';
        this.width = '3.125em';
        break;
      case 'middle':
        this.height = '1.875em';
        this.width = '4.68em';
        break;
      case 'large':
        this.height = '3.125em';
        this.width = '7.813em';
        break;
      default:
        this.height = '2.5em';
        this.width = '6.25em';
        break;
    }
  }
}
